export interface OrderState {
  orderContent: OrderContent;
  orderHistory: OrderHistory[];
}

export interface OrderHistory {
  id: string;
  status: OrderStatus;
  quantity: number;
  subtotalPriceWithTax: number;
  totalPriceWithTax: number;
  taxAmount: number;
  orderDate: string;
  pickupDate: string;
  menus: OrderMenu[];
  store: OrderStore;
  isReservation: boolean;
  isAdvancedPayment: boolean;
  isAutoOrderError: boolean;
  memo: string;
  coupon?: OrderCoupon;
  isEarlyBird: boolean;
}

export interface OrderMenu {
  id: number;
  name: string;
  code: string;
  price: number;
  quantity: number;
  options: {
    id: number;
    name: string;
  }[];
  coupon?: {
    discount: number;
    message: string;
    type: OrderMenuCouponType;
  };
  isEarlyBird: boolean;
}

export enum OrderMenuCouponType {
  Coupon = 0,
  Campaign = 1,
}

export interface OrderContent {
  menus: OrderMenu[];
  totalQuantity: number;
  totalTaxAmount: number;
  totalPriceWithTax: number;
  coupon?: OrderCoupon;
}

interface OrderStore {
  id: number;
  name: string;
  address: string;
  city: string;
  prefecture: string;
}

export interface OrderCoupon {
  discount: number;
  message: string;
  price: number;
  tax: number;
  type: OrderMenuCouponType;
}

export enum OrderStatus {
  New = "新規",
  Registered = "注文受付済み",
  Cooking = "調理開始済み",
  Completed = "お受け取り済み",
  Canceled = "キャンセル済み",
}
